// Success modal shown after waitlist signup
function SuccessModal({ isOpen, onClose, message }) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-0 sm:p-4 bg-black/50 backdrop-blur-sm">
      <div className="relative w-full h-full sm:h-auto sm:max-w-2xl bg-white sm:rounded-3xl shadow-2xl p-6 sm:p-8 max-h-[100vh] sm:max-h-[90vh] overflow-y-auto">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-slate-400 hover:text-slate-600 transition-colors"
          aria-label="Close modal"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        {/* Content */}
        <div className="text-center">
          {/* Success Icon */}
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center shadow-lg">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 6L9 17l-5-5"/>
            </svg>
          </div>

          {/* Success Message */}
          <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 mb-4">
            🎉 Success!
          </h2>
          <p className="text-base sm:text-lg text-slate-700 mb-8 max-w-md mx-auto leading-relaxed">
            {message || "You're on the list. We'll contact you when the beta launches!"}
          </p>

          {/* Close Button */}
          <button
            onClick={onClose}
            className="inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-indigo-600 to-purple-600 px-8 py-4 text-white text-lg font-bold hover:from-indigo-700 hover:to-purple-700 focus-ring shadow-lg transition-all"
          >
            Got it!
          </button>
        </div>
      </div>
    </div>
  )
}

export default SuccessModal
